import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";

import {
  FETCH_CNTRY_CRNCY_INIT_ACTION,
  FETCH_CNTRY_CRNCY_SUCCESS_ACTION,
  FETCH_CNTRY_CRNCY__FAIL_ACTION,
  FETCH_STATES_INIT_ACTION,
  FETCH_STATES_SUCCESS_ACTION,
  FETCH_STATES_FAIL_ACTION,
  FETCH_DISTRICTBYID_INIT_ACTION,
  FETCH_DISTRICTBYID_SUCCESS_ACTION,
  FETCH_DISTRICTBYID_FAIL_ACTION,
  ADD_LICENSEE_INIT_ACTION,
  ADD_LICENSEE_FAIL_ACTION,
  ADD_LICENSEE_SUCCESS_ACTION,
  FETCH_LICENSEE_INIT_ACTION,
  FETCH_LICENSEE_SUCCESS_ACTION,
  FETCH_LICENSEE_FAIL_ACTION,
  EDIT_LICENSEE_INIT_ACTION,
  EDIT_LICENSEE_SUCCESS_ACTION,
  EDIT_LICENSEE_FAIL_ACTION,
  DELETE_LICENSEE_INIT_ACTION,
  DELETE_LICENSEE_SUCCESS_ACTION,
  DELETE_LICENSEE_FAIL_ACTION
} from "./action";

//import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//var btoa = require("Base64").btoa;
//var history = createBrowserHistory();

function* fetchDistrictById(value) {
  //alert(value.value);
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/districts?stateId=` + value.value,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_DISTRICTBYID_SUCCESS_ACTION,
        payload: resJSON //was resJSON before
      });
    }
  } catch (err) {
      yield put({
        type: FETCH_DISTRICTBYID_FAIL_ACTION,
        payload: err,
      });
  }
}

function* fetchCountryCrncy(value) {
  let pageno = value.value === undefined ? 1 : value.value;

  try {
    const token = localStorage.getItem("token");

    const res = yield fetch(
      `${appConfig.ip}/countryCrncy?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CNTRY_CRNCY_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_CNTRY_CRNCY__FAIL_ACTION,
        error: err
      });
    }
  }
}

function* fetchLicenseeProfile(value) {
  const token = localStorage.getItem("token");
  let pageno = value.value === undefined ? 1 : value.value;
  try {
    const res = yield fetch(
      `${appConfig.ip}/licenseeProf?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_LICENSEE_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_LICENSEE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddLicenseeProfile(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      email: value.value.email,
      mobileNo: value.value.mobno,
      password: value.value.password,
      //glCode: value.value.glCode,
      country: value.value.country, //"India", //"5f5715ee9e2b29e675c220c9",
      curncyCode: value.value.currencyId, //"5f55e6b69e2b29e675c220b9",
      orgName: value.value.orgName,
      callingCode: value.value.countryCode,
      state: value.value.states,
      district: value.value.district,
      gstin: value.value.gstin,
      city: value.value.city,
      addr1: value.value.address1,
      addr2: value.value.address2,
      landmark: value.value.landmark,
      zip: value.value.zip,
      name: value.value.fname,
      lName: value.value.lname,
      contctPerson: value.value.spocName,
      contctNo: value.value.contNum,
      //crNumber: value.value.crno,
      //crExpDate: value.value.crExpirydate,
      spocName: value.value.spocName,
      spocDsgntn: value.value.spocDesign,
      spocEmail: value.value.spocEmail,
      spocPhn: value.value.spocPhone,
      hqAddr: value.value.hqAdd,
      hqFax: value.value.hqFax,
      hqEmail: value.value.hqEmail,
      hqPhn: value.value.hqPhone,
      taxEnble: value.value.isEnabled,
      taxPrcntg: value.value.taxPercent,
      commsnPrcntg: value.value.commPer
    };

    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",data);
    // console.log(data);

    const res = yield fetch(`${appConfig.ip}/users/createLicensee`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data) //like this before
      //body: data,
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      console.log("++++++++++++++resJSON",resJSON);
      yield put({ type: FETCH_LICENSEE_INIT_ACTION });
      yield put({
        type: ADD_LICENSEE_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Licensee details added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    // if (err.ok === false) {
    //   yield put({
    //     type: ADD_LICENSEE_FAIL_ACTION,
    //     error: err
    //   });
    // }

    if (err.ok === false) {
      if (err.status === 409) {
        yield toast.error("User already registered", {
          autoClose: 3000,
          
        });
      }
      yield put({
        type: ADD_LICENSEE_FAIL_ACTION,
        error: err,
      });
    } else {
    }


  }

}

function* editLicensee(value) {
  // console.log(value);
  try {
    const token = localStorage.getItem("token");

    const data = {
      //glCode: value.value.glCode,
      orgName: value.value.orgName,
      city: value.value.city,
      landmark: value.value.landmark,
      name: value.value.name,
      commsnPrcntg: value.value.commPer,
      lName: value.value.lname,
      addr1: value.value.address1,
      addr2: value.value.address2,
      zip: value.value.zip,
      spocName: value.value.spocName,
      spocEmail: value.value.spocEmail,
      spocDsgntn: value.value.spocDesign,
      spocPhn: value.value.spocPhone,
      hqAddr: value.value.hqAdd,
      hqFax: value.value.hqFax,
      hqEmail: value.value.hqEmail,
      hqPhn: value.value.hqPhone,
      //crNumber: value.value.crno,
      gstin: value.value.gstin,
      taxPrcntg: value.value.taxPercent,

      country: value.value.country,
      callingCode: value.value.countryCode,
      curncyCode: value.value.currencyId,
      mobileNo: value.value.mobno,
      crExpDate: value.value.crExpirydate,

      taxEnble: value.value.isEnabled,
      state: value.value.states,
      district: value.value.district
    };

    // console.log(data);

    const res = yield fetch(
      `${appConfig.ip}/licenseeProf/update/` + value.value.id,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      }
    );

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_LICENSEE_INIT_ACTION });
      yield put({
        type: EDIT_LICENSEE_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Licensee updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_LICENSEE_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* deleteLicensee(value) {
  let id = value.value;
  // let data = {
  //   isActive: false
  // };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/licenseeProf/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify()
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_LICENSEE_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000
      });
      const resJSON = yield res.json();

      yield put({
        type: DELETE_LICENSEE_SUCCESS_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_LICENSEE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchStates() {
  try {
    const token = localStorage.getItem("token");

    const res = yield fetch(`${appConfig.ip}/state/all`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_STATES_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_STATES_FAIL_ACTION,
        error: err
      });
    }
  }
}

export function* LicenseeActionWatcher() {
  yield takeEvery(FETCH_DISTRICTBYID_INIT_ACTION, fetchDistrictById);
  yield takeEvery(FETCH_CNTRY_CRNCY_INIT_ACTION, fetchCountryCrncy);
  yield takeEvery(FETCH_STATES_INIT_ACTION, fetchStates);
  yield takeEvery(ADD_LICENSEE_INIT_ACTION, AddLicenseeProfile);
  yield takeEvery(FETCH_LICENSEE_INIT_ACTION, fetchLicenseeProfile);
  yield takeEvery(EDIT_LICENSEE_INIT_ACTION, editLicensee);
  yield takeEvery(DELETE_LICENSEE_INIT_ACTION, deleteLicensee);
}
